import React from "react";
import { ReactComponent as TitleImage } from "../../../../../../assets/svgs/dashboardso701.svg";
import { ReactComponent as TitleImage1 } from "../../../../../../assets/svgs/dashboardTitleImage1.svg";
import { ReactComponent as TitleImage2 } from "../../../../../../assets/svgs/dashboardTitleImage2.svg";

import { THEME_COLORS } from "../../../../../../color";

const SupplierCalEmission = ({ getComponent, activeDashboard }) => {
  const comp = getComponent ? getComponent("sc_supplier_emissions_pct") : null;

  let scope12Display = "25% suppliers";
  let scope123Display = "15% suppliers";

  if (activeDashboard === "live" && comp?.data) {
    const s12 = comp.data.scope12 || {};
    const s123 = comp.data.scope123 || {};
    scope12Display = `${s12.count ?? 0}%  suppliers`;
    scope123Display = `${s123.count ?? 0}%  suppliers`;
  }

  return (
    <div className="px-4 py-4">
      {/* Header */}
      <div className="flex items-center ">
        <div className="p-1 flex items-center justify-center">
          <TitleImage className="w-12 h-12" />
        </div>
        <div className="px-5">
          <p
            className="text-base md:text-lg font-semibold"
            style={{ color: THEME_COLORS.green }}
          >
            Percentage Of Supplier Calculating Emissions
          </p>
        </div>
      </div>

      {/* Cards Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Card 1: Scope 1 & 2 */}
        <div className="border border-[#efefef] rounded-[10px]">
          <div className="rounded-[10px] bg-[#E5F3F6] shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#efefef]">
            <div className="flex items-center gap-4 p-0.5 ">
              <TitleImage1 className="w-8 h-8" />
              <p className="font-light text-sm">Scope 1 & 2</p>
            </div>
            <div className="px-2 ">
              <p
                className="text-lg font-semibold"
                style={{ color: THEME_COLORS.green }}
              >
                {scope12Display}
              </p>
            </div>
          </div>
          <ul className="text-xs font-light px-6 py-0.5 list-disc list-inside space-y-1">
            <li>Stationary fuel combustion</li>
            <li>Mobile fuel combustion</li>
            <li>Fugitive emission</li>
            <li>Purchased electricity</li>
            <li>Purchased heat and steam</li>
          </ul>
        </div>

        {/* Card 2: Scope 1, 2 & 3 */}
        <div className="border border-[#efefef] rounded-[10px]">
          <div className="rounded-[10px] bg-[#E5F3F6]  shadow-[0px_0px_16px_0px_#3BA2B91F] border border-[#efefef] pb-0">
            <div className="flex items-center gap-4 px-0.5">
              <TitleImage2 className="w-8 h-8" />
              <p className="font-light text-sm">Scope 1, 2 & 3</p>
            </div>
            <div className="px-0.5 ">
              <p
                className="text-lg font-semibold"
                style={{ color: THEME_COLORS.green }}
              >
                {scope123Display}
              </p>
            </div>
          </div>
          <ul className="text-xs font-light px-2  list-disc list-inside ">
            <li>Fugitive emission</li>
            <li>Purchased electricity</li>
            <li>Purchased goods & services</li>
            <li>Upstream transportation</li>
            <li>Employee commuting</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SupplierCalEmission;
